import { z } from "zod";

/** Money is always stored as an integer number of rial (AGENTS.md §3.6). Never a float. */
export const Rial = z.int().nonnegative().brand<"Rial">();
export type Rial = z.infer<typeof Rial>;

export const RIAL_PER_TOMAN = 10;

/** Display helper: rial → toman, rounding half away from zero is never needed because 1 toman = 10 rial exactly. */
export function rialToToman(amount: Rial): number {
  return Math.trunc(amount / RIAL_PER_TOMAN);
}
